import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { isDefined } from '@grandvisionhq/utils';
import { PriceTagOrIncluded } from '../../../components/PriceTagOrIncluded/PriceTagOrIncluded.js';

const ConfigurationSummaryRow = ({ label , value , price , discountText , className , pricePrefix , step , 'data-t': dataT ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('configuration-summary-row', className),
        "data-t": dataT || 'configuration-summary-row'
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("strong", {
        className: "configuration-summary-row__label"
    }, label || ''), /*#__PURE__*/ React.createElement("span", {
        className: "configuration-summary-row__value"
    }, value || '')), isDefined(price) && /*#__PURE__*/ React.createElement(PriceTagOrIncluded, swcHelpers.extends({}, price, {
        discountText: discountText,
        prefix: pricePrefix,
        step: step
    })));
};

export { ConfigurationSummaryRow as default };
//# sourceMappingURL=ConfigurationSummaryRow.js.map
